"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const icon_1 = __importDefault(require("../../components/icon/icon"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const styles_1 = __importDefault(require("../../styles/styles"));
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const button_1 = __importDefault(require("../../components/button/button"));
const themes_1 = __importDefault(require("../../styles/themes"));
const constants_1 = require("../../constants/constants");
const eventConstants_1 = require("../../constants/eventConstants");
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const scheduleSlice_1 = require("../schedules/scheduleSlice");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const Search = () => {
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const { errorMessage, loadingStatus } = useAppSelector_1.default((state) => ({
        errorMessage: state.schedule.errorMessage,
        loadingStatus: state.schedule.status,
    }));
    const [scheduleId, setScheduleId] = react_1.useState('');
    const searchButtonText = loadingStatus === typesConstants_1.PENDING_STATUS ? 'Loading' : 'Search';
    let errorState = react_1.default.createElement(react_native_1.View, null);
    const isError = loadingStatus === typesConstants_1.FAILED_STATUS;
    // Every time we enter the page, we need to clear any current errors in the store
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(scheduleSlice_1.resetScheduleState());
        setScheduleId('');
    }, []));
    if (isError) {
        errorState = react_1.default.createElement(react_native_paper_1.Subheading, { style: styles_1.default.textColorRed }, errorMessage);
    }
    const performSearch = () => {
        dispatch(scheduleSlice_1.getSchedule({ scheduleId })).then((response) => {
            if (response.meta.requestStatus === constants_1.FULFILLED_RESPONSE_CONSTANT) {
                navigator.navigate(screenConstants_1.SCHEDULE_SCREEN, { schedule_id: scheduleId });
            }
        });
    };
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS === constants_1.WEB_TAG ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Search Schedule" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_DASHBOARD_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Dashboard `)))))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChilds] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                    react_1.default.createElement(react_native_1.View, null, errorState),
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "Schedule ID", placeholder: "Enter schedule id", onChangeText: setScheduleId, error: false, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: scheduleId }),
                    react_1.default.createElement(button_1.default, { text: searchButtonText, onPress: performSearch, fill: true, eventName: eventConstants_1.SEARCH_SCHEDULE_BUTTON }))))));
};
exports.default = Search;
